<template>
  <div class="poster-clamp">
    <div
      ref="body"
      :class="['poster-clamp-body', { 'poster-clamp-closed': !open, 'poster-clamp-faded': !open && overflows }]"
      :style="open ? {} : { maxHeight: `${lines * lineHeight}px` }"
    >
      <slot/>
    </div>
    <button
      v-if="overflows"
      type="button"
      class="poster-clamp-toggle"
      :aria-expanded="open ? 'true' : 'false'"
      @click="open = !open"
    >
      {{ open ? t('showLess') : t('showMore') }}
      <svg :class="{ 'poster-clamp-flip': open }" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
        <path fill="currentColor" d="M7.4 8.6 12 13.2l4.6-4.6L18 10l-6 6-6-6z"/>
      </svg>
    </button>
  </div>
</template>

<script>
import { translationMixin } from "@/mixins/translationMixin";

/**
 * Long text cut to a few lines with a fade, and a show more / show less
 * button. The button appears only when the text is really longer than that.
 *
 * lineHeight must match the slot text's line-height, in px.
 */
export default {
  name: 'PosterClamp',
  mixins: [translationMixin],
  props: {
    lines: { type: Number, default: 4 },
    lineHeight: { type: Number, default: 26 },
  },
  data() {
    return { open: false, overflows: false };
  },
  mounted() {
    this.measure();
    window.addEventListener('resize', this.measure);
  },
  updated() {
    if (!this.open) this.measure();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.measure);
  },
  methods: {
    measure() {
      const body = this.$refs.body;
      if (!body || this.open) return;
      const overflows = body.scrollHeight > body.clientHeight + 2;
      if (overflows !== this.overflows) this.overflows = overflows;
    },
  },
};
</script>

<style scoped>
.poster-clamp-body {
  position: relative;
}

.poster-clamp-closed {
  overflow: hidden;
}

.poster-clamp-faded {
  -webkit-mask-image: linear-gradient(to bottom, #000 55%, transparent);
  mask-image: linear-gradient(to bottom, #000 55%, transparent);
}

.poster-clamp-toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 6px;
  padding: 4px 0;
  border: 0;
  background: none;
  color: var(--primary-color, #07A0C3);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.poster-clamp-toggle svg {
  transition: transform 0.2s ease;
}

.poster-clamp-flip {
  transform: rotate(180deg);
}
</style>
